import React, { useState } from "react";
import "./changepassword.css";
import Logo from "../../assets/logo_t.png";
import EmailImg from "../../assets/email.png";
import axios from "axios";
import { toast } from "react-toastify";

const Changepassword = () => {
  const [resetEmail, setResetEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    if (!resetEmail) {
      toast.error("Please enter your email address.");
      setIsSubmitting(false);
      return;
    }

    const url = "https://backend.goldengirlsonthemove.com";

    axios
      .post(`${url}/auth/forgot_password`, { email: resetEmail })
      .then((result) => {
        if (result.data.Status) {
          toast.success(result.data.Message);
        } else {
          toast.error(result.data.Message);
        }
      })
      .catch((err) => {
        // console.log(err);
        toast.error("An error occurred. Please try again.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div id="changePassword">
      <form>
        <div className="reset_container">
          <div className="resetImageDiv">
            <img src={Logo} alt="resetImage" className="resetImage"></img>
          </div>
          <div className="reset__emailIntro">
            <div className="sideline"></div>
            <p className="reset__emailPara">
              You will receive a link to reset your password
            </p>
            <div className="sideline"></div>
          </div>
          <div className="reset__Input">
            <img src={EmailImg} alt="" />
            <input
              type="email"
              name="reset__email"
              value={resetEmail}
              className="password__reset-email"
              placeholder="Your email address"
              onChange={(e) => setResetEmail(e.target.value)}
            ></input>
          </div>
          <button
            type="submit"
            onClick={handleSubmit}
            className="reset__passwordBtn"
          >
            {isSubmitting ? "Sending..." : "Reset"}
          </button>
          <div className="reset__Text">
            <div>
              <a href="/login">Login</a>
            </div>
            <span>
              Don't have an account? <a href="/register">Register Here</a>
            </span>
            <p></p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Changepassword;
